import { FC, ReactNode } from "react";

import RadioInput from "./RadioInput";
import { Error } from "./styles/Error.styled";
import { RadioInputsWrapper } from "./styles/RadioInputsWrapper";
import { Radios } from "./styles/Radios.styled";

export interface RadioInputOption {
  label: ReactNode;
  value: string;
  disabled?: boolean;
}

interface RadioGroupProps {
  id: string;
  value?: string;
  label: ReactNode;
  options: RadioInputOption[];
  name: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  error: string | null;
}

const RadioGroup: FC<RadioGroupProps> = ({
  id,
  label,
  value,
  options,
  name,
  onChange,
  onFocus,
  error,
}) => {
  return (
    <Radios id={id}>
      {label}
      <RadioInputsWrapper>
        {options.map((option) => (
          <RadioInput
            key={`option-${option.value}`}
            checked={option.value === value}
            label={option.label}
            name={name}
            value={option.value}
            disabled={!!option.disabled}
            onChange={() => onChange(option.value)}
            onFocus={onFocus}
          />
        ))}
      </RadioInputsWrapper>
      {error ? <Error>{error}</Error> : null}
    </Radios>
  );
};

export default RadioGroup;
